import { Injectable } from '@angular/core';
import { TranslateLoader, type TranslationObject } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';
import type { Language } from 'src/app/core/constants/language-and-locale-constants';

@Injectable()
export class TranslateLoaderService implements TranslateLoader {
  public getTranslation(lang: Language): Observable<TranslationObject> {
    return from(import(`../../../assets/i18n/${lang}.json`));
  }
}
